import { ReactComponent as NARRATIVE_TEXT } from 'assets/icons/NARRATIVE_TEXT.svg';
import { ReactComponent as LETTER_NAMING } from 'assets/icons/LETTER_NAMING.svg';
import { ReactComponent as INFORMATIONAL_TEXT } from 'assets/icons/INFORMATIONAL_TEXT.svg';
import { ReactComponent as LETTER_VOWEL_CLUSTERS } from 'assets/icons/LETTER_VOWEL_CLUSTERS.svg';
import { ReactComponent as LETTER_SOUNDS } from 'assets/icons/LETTER_SOUNDS.svg';
import { ReactComponent as VOWEL_SOUND } from 'assets/icons/VOWEL_SOUND.svg';
import { ReactComponent as BIBLICAL_TEXT } from 'assets/icons/BIBLICAL_TEXT.svg';
import { ReactComponent as REAL_WORDS } from 'assets/icons/REAL_WORDS.svg';
import { ReactComponent as MULTIPLE_CHOICE_QUESTIONS } from 'assets/icons/MULTIPLE_CHOICE_QUESTIONS.svg';

const categories = {
    FINAL_LETTERS: "FINAL_LETTERS",
    REAL_WORDS_NO_NIKUD: "REAL_WORDS_NO_NIKUD",
    BIBLICAL_TEXT: "BIBLICAL_TEXT",
    REAL_WORDS: "REAL_WORDS",
    NARRATIVE_TEXT: "NARRATIVE_TEXT",
    INFORMATIONAL_TEXT_NO_NIKUD: "INFORMATIONAL_TEXT_NO_NIKUD",
    NARRATIVE_TEXT_NO_NIKUD: "NARRATIVE_TEXT_NO_NIKUD",
    INFORMATIONAL_TEXT: "INFORMATIONAL_TEXT",
    LETTER_VOWEL_CLUSTERS: "LETTER_VOWEL_CLUSTERS",
    LETTER_NAMING: "LETTER_NAMING",
    LETTER_SOUNDS: "LETTER_SOUNDS",
    VOWEL_SOUND: "VOWEL_SOUND",
    MULTIPLE_CHOICE_QUESTIONS: "MULTIPLE_CHOICE_QUESTIONS",
    NONSENSE_WORDS: "NONSENSE_WORDS"
}

const categoriesWithIcons = {
    [categories.INFORMATIONAL_TEXT]: {
        icon: INFORMATIONAL_TEXT,
        chipColor: "error",
        label: "טקסט מידעי"
    },
    [categories.INFORMATIONAL_TEXT_NO_NIKUD]: {
        icon: INFORMATIONAL_TEXT,
        chipColor: "error",
        label: "טקסט מידעי לא מנוקד"
    },
    [categories.LETTER_NAMING]: {
        icon: LETTER_NAMING,
        chipColor: "thirdly",
        label: "שיום אותיות"
    },
    [categories.FINAL_LETTERS]: {
        icon: LETTER_NAMING,
        chipColor: "thirdly",
        label: "שיום אותיות סופיות"
    },
    [categories.MULTIPLE_CHOICE_QUESTIONS]: {
        icon: MULTIPLE_CHOICE_QUESTIONS,
        chipColor: "thirdly",
        label: "שאלון בחירה מרובה"
    },
    [categories.NARRATIVE_TEXT]: {
        icon: NARRATIVE_TEXT,
        label: "טקסט סיפורי",
        chipColor: "secondary"
    },
    [categories.NARRATIVE_TEXT_NO_NIKUD]: {
        icon: NARRATIVE_TEXT,
        label: "טקסט סיפורי לא מנוקד",
        chipColor: "secondary"
    },
    [categories.NARRATIVE_TEXT]: {
        icon: NARRATIVE_TEXT,
        label: "טקסט סיפורי",
        chipColor: "secondary"
    },
    [categories.LETTER_VOWEL_CLUSTERS]: {
        icon: LETTER_VOWEL_CLUSTERS,
        label: "צירופים",
        chipColor: "error"
    },
    [categories.LETTER_SOUNDS]: {
        icon: LETTER_SOUNDS,
        label: "צליל האות",
        chipColor: "error"
    },
    [categories.VOWEL_SOUND]: {
        icon: VOWEL_SOUND,
        label: "צלילי תנועות",
        chipColor: "error"
    },
    [categories.BIBLICAL_TEXT]: {
        icon: BIBLICAL_TEXT,
        label: "טקסט מקראי",
        chipColor: "yellow"
    },
    [categories.REAL_WORDS]: {
        icon: REAL_WORDS,
        label: "רשימת מילים",
        chipColor: "green"
    },
    [categories.REAL_WORDS_NO_NIKUD]: {
        icon: REAL_WORDS,
        label: "רשימת מילים לא מנוקדות",
        chipColor: "green"
    },
    [categories.NONSENSE_WORDS]: {
        icon: REAL_WORDS,
        label: "מילות תפל",
        chipColor: "green"
    },
    ["default"]: {
        icon: INFORMATIONAL_TEXT
    }
}

export { categoriesWithIcons }
export default categories